import { apiClient } from '../../../../helpers/api_helper';

export const getAllDiscountData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/ConsumerOffers/GetAllDiscountList`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getDiscountById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/ConsumerOffers/GetDiscountDetailsById?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getMRPTypeSelectList = async (params?: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/ConsumerOffers/GetMrpTypeSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getDiscountTypeSelectList = async (params?: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/ConsumerOffers/GetDiscountTypeSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getDiscountOnMRPSelectList = async (params?: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/ConsumerOffers/GetDiscountOnMRPSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getDiscountOnSRPSelectList = async (params?: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/ConsumerOffers/GetDiscountOnSRPSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const createDiscount = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/ConsumerOffers/InsertDiscount', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateDiscount = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/ConsumerOffers/UpdateDiscount', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteDiscount = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/ConsumerOffers/DeleteDiscount?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};